import { render, staticRenderFns } from "./HelpdeskTicketModal.vue?vue&type=template&id=ca37d3cc&scoped=true&"
import script from "./HelpdeskTicketModal.vue?vue&type=script&lang=ts&"
export * from "./HelpdeskTicketModal.vue?vue&type=script&lang=ts&"
import style0 from "./HelpdeskTicketModal.vue?vue&type=style&index=0&id=ca37d3cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca37d3cc",
  null
  
)

export default component.exports